import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserSocialSecurityFormService } from "Bands/services";
import { USER_ACTIONS, IUserSocialSecurityFormPatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserSocialSecurityForms = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserSocialSecurityForms({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserSocialSecurityForms,
    })
  );
};

const getUserSocialSecurityForms = createAsyncThunk(
  USER_ACTIONS.getUserSocialSecurityForms,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserSocialSecurityFormService.getUserSocialSecurityForms({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userSocialSecurityForm]: data.userSocialSecurityForm,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserSocialSecurityForm = createAsyncThunk(
  USER_ACTIONS.createUserSocialSecurityForm,
  async (form: IUserSocialSecurityFormPatchData, { rejectWithValue }) => {
    try {
      const data = await UserSocialSecurityFormService.createUserSocialSecurityForm(form);
      const id = Object.values(data?.userSocialSecurityForm)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserSocialSecurityForm = createAsyncThunk(
  USER_ACTIONS.editUserSocialSecurityForm,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserSocialSecurityFormPatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserSocialSecurityFormService.editUserSocialSecurityForm(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserSocialSecurityForm = createAsyncThunk(
  USER_ACTIONS.deleteUserSocialSecurityForm,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserSocialSecurityFormService.deleteUserSocialSecurityForm(id);
      return {
        path: API_ENDPOINTS.USER_SOCIAL_SECURITY_FORM(id),
        dataKey: IDataKeys.userSocialSecurityForm,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
